import { create } from 'apisauce';
import { getQueryString } from '../functions';
import { getCookies } from '../store/useCookies';
import { env } from '../utils/env/config';
export const ip = 'http://192.168.1.169:2000';

export const MODE_API = {
  DEVELOPMENT: env.url_dev,
  UAT: env.url_uat,
  PRODUCTION: env.url_prd,
};
// export const CONNECT_API = 'https://jsonplaceholder.typicode.com';
export const CONNECT_API = MODE_API[`${env.node_env}`.toUpperCase()];
const api = create({
  baseURL: CONNECT_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds
});

const apiupload = create({
  baseURL: CONNECT_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
/**
 * ฟังก์ชั่นสำหรับ ยิงข้อมูล
 * @param {string} path
 * @param {{}} obj
 * @return {{}}
 */
export const POST = (path, obj, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .post(path, obj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.ok) {
          resolve(response.data);
        } else {
          response.data
            ? reject(response.data)
            : reject({ success: false, message: response.problem });
        }
      })
      .catch((err) => reject(err));
  });

/**
 * ฟังก์ชั่นสำหรับ ยิงข้อมูล
 * @param {string} path
 * @param {{}} obj
 * @return {{}}
 */
export const PUT = (path, obj, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .put(path, obj, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .then((response) => {
        if (response.ok) {
          resolve(response.data);
        } else {
          response.data
            ? reject(response.data)
            : reject({ success: false, message: response.problem });
        }
      })
      .catch((err) => reject(err));
  });

/**
 * ฟังก์ชั่นสำหรับ ดึงข้อมูล
 * @param {string} path
 *
 */
export const GET = (path, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .get(
        path,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        },
      )
      .then((response) => {
        if (response.ok) {
          resolve(response.data);
        } else {
          response.data
            ? reject(response.data)
            : reject({ success: false, message: response.problem });
        }
      })
      .catch((err) => reject(err));
  });

export const UPLOAD = (path, formdata, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    apiupload
      .post(path, formdata, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .then((response) => {
        if (response.ok) {
          resolve(response.data);
        } else {
          response.data
            ? reject(response.data)
            : reject({ success: false, message: response.problem });
        }
      })
      .catch((err) => reject(err));
  });

/* ################################################## URL ################################################## */
export const LOGIN = `/authen/login`;
export const LOGIN_GOOGLE = `/authen/login-google`;
export const REGISTER = `/authen/register`;
export const GET_PROFILE = `/authen/get_profile`;
export const GET_ALL_PRODUCT = `/product/get-all`;
export const GET_PRODUCT_SEARCH = (obj) => `/product/search?${getQueryString(obj)}`;

export const GET_ALL_POST = `/posts`;
export const INSERT_POST = `/posts`;
export const UPDATE_POST = (id) => `/posts/${id}`;
export const GET_POST_BY_ID = (id) => `/posts/${id}`;

//initiate user
export const GET_CUSTOMER_LINE = (userId) =>
  `/warranty/rizz/api/v2/line/customers/lineuid/${userId}`;

//Entertel
export const POST_OTP_CALL = () => `/warranty/rizz/api/v2/line/otp/call`;
export const POST_OTP_VERIFY = () => `/warranty/rizz/api/v2/line/otp/verify`;
export const GET_PDPA_DATA = () => `/warranty/rizz/api/v2/line/options/policies/pdpa`;

//Register
export const GET_BARCORE = (barcode) =>
  `/warranty/rizz/api/v2/line/options/products/barcode/${barcode}`;
export const POST_REGISTER_INFO = () => `/warranty/rizz/api/v2/line/warranties/add`;
export const POST_INSERT_CLAIM = () => `/warranty/rizz/api/v2/line/claims/insert`;

//Claim
export const POST_CLAIM_VERIFY = `/warranty/rizz/api/v2/line/claims/warranty/verify`;

//home
export const GET_ITEMS = (userId) => `/warranty/rizz/api/v2/line/items/${userId}`;

//options
export const GET_CHANNEL_BUYS = () => `/warranty/rizz/api/v2/line/options/channel-buys`;
export const GET_MOBILE_BRANDS = () => `/warranty/rizz/api/v2/line/options/mobile-brands`;
export const GET_BREAKDOWN_SUBS = (productType) =>
  `/warranty/rizz/api/v2/line/options/breakdowns/sub?productType=${encodeURIComponent(productType)}`;
export const GET_CLAIM_ZIPCODE = (zipcode) =>
  `/warranty/rizz/api/v2/line/options/addresses/zipcode/${zipcode}`;
export const GET_POLICIES_DATA = () =>
  `/warranty/rizz/api/v2/line/options/policies/warranty/agreement`;
export const GET_BREAKDOWN_SUB_OPTIONS = (productType) =>
  `/warranty/rizz/api/v2/line/options/breakdowns/sub?productType=${productType}`;